import { configureStore } from '@reduxjs/toolkit'
import userReducer from './authSlice'
import dashboardReducer from './dashboardSlice'
export const store = configureStore({
    reducer: {
        auth: userReducer,
        dashboard:dashboardReducer
    },
})